module.exports = __webpack_public_path__ + "img/standard.ebfe73d3.png";